import { graphql } from '@eluve/graphql.tada';

export const searchCodesQuery = graphql(`
  query searchCodes(
    $searchTerm: String
    $userGroupId: uuid!
    $tenantId: uuid!
    $limit: Int
    $offset: Int
    $orderBy: [UserGroupCodeConfigsOrderBy!]
  ) {
    userGroupsByPk(id: $userGroupId, tenantId: $tenantId) {
      __typename
      id
      configs(
        where: {
          _and: {
            deletedAt: { _isNull: true }
            _or: [
              { medical_code: { code: { _ilike: $searchTerm } } }
              { label: { _ilike: $searchTerm } }
            ]
          }
        }
        limit: $limit
        offset: $offset
        orderBy: $orderBy
      ) {
        __typename
        id
        label
        price
        modifiers
        medical_code {
          __typename
          code
          codeType
        }
        tenantId
      }
    }
    userGroupCodeConfigsAggregate(
      where: {
        groupId: { _eq: $userGroupId }
        tenantId: { _eq: $tenantId }
        deletedAt: { _isNull: true }
        _or: [
          { medical_code: { code: { _ilike: $searchTerm } } }
          { label: { _ilike: $searchTerm } }
        ]
      }
    ) {
      __typename
      aggregate {
        __typename
        count
      }
    }
  }
`);

export const createUserGroupCodeConfigMutation = graphql(`
  mutation createUserGroupCodeConfig(
    $userGroupId: uuid!
    $label: String
    $price: Int
    $modifiers: jsonb
    $codeId: uuid!
  ) {
    insertUserGroupCodeConfigsOne(
      object: {
        groupId: $userGroupId
        label: $label
        price: $price
        modifiers: $modifiers
        codeId: $codeId
      }
    ) {
      __typename
      id
      label
      price
      modifiers
    }
  }
`);
